<template>
    <div v-if="waitingMessage" class="waiting-message">
        <div class="loading-overlay">
            <div class="loader" />
            <div class="ml-2 animated-text-column">
                <div class="animated-text-line">
                    <span
                        v-for="(char, index) in characters"
                        :key="'primary-' + index"
                        class="fade-in-left-letter"
                        :style="{ animationDelay: `${index * 0.1}s` }"
                    >{{ char === ' ' ? '\u00A0' : char }}</span>
                </div>
                <div class="animated-text-line secondary-line">
                    <span
                        v-for="(char, index) in secondaryCharacters"
                        :key="'secondary-' + index"
                        class="fade-in-left-letter"
                        :style="{ animationDelay: `${(characters.length * 0.1) + 2 + (index * 0.1)}s` }"
                    >{{ char === ' ' ? '\u00A0' : char }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            waitingMessage: {
                type: String,
                required: true
            }
        },
        computed: {
            characters() {
                return (this.waitingMessage || '').split('')
            },
            secondaryCharacters() {
                return 'Παρακαλώ περιμένετε, διατηρήστε την σελίδα ενεργή...'.split('')
            }
        }
    }
</script>

<style scoped>
.waiting-message {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
    font-size: 1rem;
    padding-left: 2rem;
    padding-right: 2rem;
    color: var(--cards-and-tables-text-color);
}

.loading-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    width: 100%;
}
.loader {
    margin-right: 0.2rem;
    min-width: 2rem;
    min-height: 2rem;
    transform: translateZ(0);
    box-sizing: border-box;
    width: 2rem;
    height: 2rem;
    border: 0.2em solid rgba(255, 255, 255, 0.3);
    border-top: 0.2rem solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.animated-text-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.secondary-line {
    font-size: 0.85em;
    margin-top: 0.2rem;
}

.fade-in-left-letter {
    display: inline-block;
    opacity: 0;
    animation: fadeInLeft 2s ease-out forwards;
}

@keyframes fadeInLeft {
    0% {
        opacity: 0;
        transform: translateX(10px);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}
</style>
